import { Navigate } from "react-router-dom";
import { DASHBOARD_PROGRAME, SELF_PACED_PROGRAME } from "utils/constants";

interface PrivateRouteProps {
  children: any;
  token: any;
  allowedProgramType?: "3" | "4"; // allowed program types for the route according to api data.
  shouldRenderOnboardingForms?: boolean;
}

const PrivateRoute = ({
  children,
  token,
  allowedProgramType,
  shouldRenderOnboardingForms,
}: PrivateRouteProps) => {
  try {
    // NOTE: Check if the token is expired and redirect to login page.
    // This is handled in api.ts file.

    // Check if the program type matches the allowed program type for this route
    if (
      token.programtype === allowedProgramType ||
      shouldRenderOnboardingForms === true
    ) {
      return children;
    } else {
      if (allowedProgramType === SELF_PACED_PROGRAME) {
        // If the route is /self-paced, and the programtype doesn't match, redirect to "/"
        return <Navigate to="/" />;
      } else if (allowedProgramType === DASHBOARD_PROGRAME) {
        // If the route is "/", and the programtype doesn't match, redirect to "/self-paced"
        return <Navigate to="/self-paced" />;
      }
    }
  } catch (error) {
    console.error("Invalid token", error);
    return <Navigate to="/" />;
  }
};

export default PrivateRoute;
